module.exports = __webpack_public_path__ + "2b356b69.svg";